import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import configureStore from "./configureStore";
import App from "@app/containers/App";
import { urlParam } from "utils/helpers";
import { storeUrlParams, clearLocalStorage } from "utils/localStorage";
import CleverTapAnalytics from "analytics/type/CleverTapAnalytics";
import "assets/css/app.scss";
import "assets/css/tailwind.css";

const { persistor, store } = configureStore();

if (urlParam("reset")) {
  clearLocalStorage();
  persistor.purge();
  // Clear Old CleverTap ID to maintain unique users
  CleverTapAnalytics.clearOldCleverTapID();
  if (window && window.koreLogout) {
    window.koreLogout();
  }
}

storeUrlParams();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App persistor={persistor} store={store} />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
